import { idmsApi } from "./api";
import { API_PRODUCT_ENDPOINT } from "../../constants/endpoints";
import { convertObjectToQueryParams } from "../../util/convertObjectToQueryParams";

const productApi = idmsApi.injectEndpoints({
  endpoints: (builder) => ({
    createProduct: builder.mutation<any, CreateProduct>({
      query: (request) => ({
        url: API_PRODUCT_ENDPOINT,
        method: "POST",
        body: request,
      }),
    }),

    getProducts: builder.query<any, GetProductsSearchCriteria>({
      query: (getProductsSearchCriteria) =>
        `${API_PRODUCT_ENDPOINT}?${convertObjectToQueryParams(
          getProductsSearchCriteria
        )}`,
      providesTags: (result) => ["Product"],
    }),

    updateProduct: builder.mutation<any, UpdateProduct>({
      query: ({ productId, product }) => ({
        url: `${API_PRODUCT_ENDPOINT}/updateProduct/${productId}`,
        method: "PUT",
        body: product,
      }),
      invalidatesTags: ["Product"],
    }),

    deleteProduct: builder.mutation<any, string>({
      query: (productId) => ({
        url: `${API_PRODUCT_ENDPOINT}/${productId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Product", "ProductFeatures", "ProductSubscriptions"],
    }),

    createProductFeature: builder.mutation<any, CreateProductFeatureReq>({
      query: ({ productId, body }) => ({
        url: `${API_PRODUCT_ENDPOINT}/${productId}/features`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["ProductFeatures"],
    }),

    getProductFeatures: builder.query<any, ProductFeature>({
      query: ({ productId, page, pageSize }) =>
        `${API_PRODUCT_ENDPOINT}/${productId}/features?${convertObjectToQueryParams(
          {
            page,
            pageSize,
          }
        )}`,
      providesTags: (result, _err, arg) => [{ type: "ProductFeatures", id: arg.productId }],
    }),

    updateProductFeature: builder.mutation<any, UpdateProductFeatureReq>({
      query: ({ productFeatureId, productFeature }) => ({
        url: `${API_PRODUCT_ENDPOINT}/${productFeatureId}`,
        method: "PUT",
        body: productFeature,
      }),
      invalidatesTags: ["ProductFeatures"],
    }),

    deleteProductFeature: builder.mutation<any, DeleteFeatureReq>({
      query: (body) => ({
        url: `${API_PRODUCT_ENDPOINT}/deleteFeatures`,
        method: "DELETE",
        body,
      }),
      invalidatesTags: ["ProductFeatures"],
    }),
    getAllProdcutsFeatures: builder.query<PaginatedProductsWithFeaturesDto, { page: number; pageSize: number }>({
      query: ({ page, pageSize }) => ({
        url: `${API_PRODUCT_ENDPOINT}/products/features?${convertObjectToQueryParams({
          page,
          pageSize,
        })}`,
        method: "GET",
      }),
      providesTags: ["ProductFeatures"],
    }),
  
    // Replace all tiers' feature assignments for a product (single atomic call)
    updateProductTiersFeatures: builder.mutation<void, { productId: string; tiers: { subscriptionId: string; featureIds: string[] }[] }>({
      query: ({ productId, tiers }) => ({
        url: `${API_PRODUCT_ENDPOINT}/${productId}/tiers/features`,
        method: "PUT",
        body: { tiers },
      }),
      invalidatesTags: (result, _err, arg) => [
        { type: "ProductSubscriptions", id: arg.productId },
        "SubscriptionFeatures",
      ],
    }),

    getTopProductAdoption: builder.query<Array<{ productId: string; productName: string; dealersCount: number }>, number | void>({
      // arg = take (optional)
      query: (take = 5) => `${API_PRODUCT_ENDPOINT}/top-adoption?take=${take}`,
      providesTags: ["Product"],
    }),
  }),
});

export const {
  useCreateProductMutation,
  useGetProductsQuery,
  useUpdateProductMutation,
  useDeleteProductMutation,
  useGetAllProdcutsFeaturesQuery,

  useCreateProductFeatureMutation,
  useGetProductFeaturesQuery,
  useUpdateProductFeatureMutation,
  useDeleteProductFeatureMutation,
  useUpdateProductTiersFeaturesMutation,
  useGetTopProductAdoptionQuery,
} = productApi;
